import { Form, Link, useActionData, useNavigation } from 'react-router';

export function RegisterPage() {
  const actionData = useActionData() as { error?: string; values?: any } | undefined;
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  return (
    <>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-foreground">
          Create Account
        </h2>
        <p className="mt-2 text-muted-foreground">
          Join us to start your job search journey
        </p>
      </div>

      {actionData?.error && (
        <div className="mb-6 rounded-lg bg-destructive/10 border border-destructive/20 p-4">
          <p className="text-sm text-destructive">{actionData.error}</p>
        </div>
      )}

      <Form method="post" className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label htmlFor="firstName" className="text-sm font-medium text-foreground">
              First Name
            </label>
            <input
              id="firstName"
              name="firstName"
              type="text"
              autoComplete="given-name"
              required
              defaultValue={actionData?.values?.firstName || ''}
              className="input"
              placeholder="John"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="lastName" className="text-sm font-medium text-foreground">
              Last Name
            </label>
            <input
              id="lastName"
              name="lastName"
              type="text"
              autoComplete="family-name"
              required
              defaultValue={actionData?.values?.lastName || ''}
              className="input"
              placeholder="Doe"
            />
          </div>
        </div>

        <div className="space-y-2">
          <label htmlFor="email" className="text-sm font-medium text-foreground">
            Email address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            defaultValue={actionData?.values?.email || ''}
            className="input"
            placeholder="john.doe@example.com"
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="password" className="text-sm font-medium text-foreground">
            Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="new-password"
            required
            defaultValue=""
            className="input"
            placeholder="At least 8 characters"
          />
          <p className="text-xs text-muted-foreground">
            Must be at least 8 characters with uppercase, lowercase, and numbers
          </p>
        </div>

        <div className="space-y-2">
          <label htmlFor="confirmPassword" className="text-sm font-medium text-foreground">
            Confirm Password
          </label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            required
            defaultValue=""
            className="input"
            placeholder="Re-enter your password"
          />
        </div>

        <div className="flex items-start space-x-3">
          <input
            id="agreeToTerms"
            name="agreeToTerms"
            type="checkbox"
            className="mt-1 h-4 w-4 text-primary border-border rounded focus:ring-primary/20"
            required
          />
          <label htmlFor="agreeToTerms" className="text-sm text-muted-foreground">
            I agree to the{' '}
            <Link to="/legal/terms" className="font-medium text-primary hover:text-chefchaouen-blue-600 transition-colors">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/legal/privacy" className="font-medium text-primary hover:text-chefchaouen-blue-600 transition-colors">
              Privacy Policy
            </Link>
          </label>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="btn btn-primary w-full h-12 text-base click-scale"
        >
          {isSubmitting ? 'Creating account...' : 'Create Account'}
        </button>
      </Form>

      <div className="mt-6">
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-border" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-card text-muted-foreground">Or</span>
          </div>
        </div>

        <div className="mt-6 text-center">
          <span className="text-sm text-muted-foreground">
            Already have an account?{' '}
            <Link to="/login" className="font-medium text-primary hover:text-chefchaouen-blue-600 transition-colors">
              Sign in
            </Link>
          </span>
        </div>
      </div>
    </>
  );
}